export default {
  getList(state) {
    return state.list;
  },

  getDetail(state) {
    return state.detail;
  },

  getPageInfo(state) {
    return state.pageInfo;
  }
};
